import { ContainerFluid } from "./grid-container-fluid";
import { ContainerWrapper } from "./grid-container-wrapper";
import { Container } from "./grid-container";
import { Row } from "./grid-row";
import { Column } from "./grid-column";
import { Item } from "./grid-item";

// Define the main object for your package
const CpdsGridSystem = {
  ContainerFluid, 
  ContainerWrapper,
  Container,
  Row,
  Item,
  Column
};

// Export the main object for access like Csystem.Container
export default CpdsGridSystem;